import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isSentLoaded: false,
    sentList: []
}

const eventsSlice = createSlice({
    name: 'sentlists', 
    initialState,
    extraReducers: (builder) => {

        builder.addCase(actions.getSentAll.pending, (state) => {
            state.isSentLoaded = false;
        })
        builder.addCase(actions.getSentAll.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.sentList = action.payload.data;
            } else {
                state.sentList = [];
            }
            state.isSentLoaded = true;
        })
        builder.addCase(actions.getSentAll.rejected, (state) => {
            state.isSentLoaded = false;
        }); 
    }
});

export default eventsSlice.reducer;